
    import I18n from 'i18nObj';
    
      import 'translations/cyoe_assignment_sidebar_student_ranges_view';
      import 'translations/_core';
    
    import 'translations/_core_en';

    export default I18n.scoped('cyoe_assignment_sidebar_student_ranges_view');
  